import React, { useContext } from "react";
import { IconsContext } from "../context";
import { twMerge } from "tailwind-merge";
const Icon = (props) => {
    const icons = useContext(IconsContext);
    const style = {
        width: icons.size,
        height: icons.size,
    };
    return (React.createElement("svg", { className: twMerge("icon", props.className), style: style },
        React.createElement("use", { href: `${icons.path}#${props.name}` })));
};
export default Icon;
//# sourceMappingURL=Icon.js.map